// Политика авто-переподключения после восстановимого обрыва.
//
// Успехом считается только состоявшийся звонок: статус `connected` приходит
// сразу после сигналинга — раньше, чем поднялись микрофон и камера, — поэтому
// сам факт `connected` счётчик попыток обнулять не вправе. Обрыв через доли
// секунды после входа означает петлю «зашёл → отвалился → перезашёл», и без
// порога стабильности она крутится бесконечно.

export const MAX_REJOIN_ATTEMPTS = 3

// Сколько звонок должен продержаться, чтобы считаться состоявшимся.
export const STABLE_SESSION_MS = 15_000

// Номер следующей попытки: состоявшийся звонок начинает счёт заново, мгновенный
// обрыв продолжает текущую серию. sessionMs = null — до комнаты так и не дошли.
export function nextRejoinAttempt(attempts: number, sessionMs: number | null): number {
  if (sessionMs != null && sessionMs >= STABLE_SESSION_MS) return 1
  return attempts + 1
}

export function rejoinExhausted(attempt: number): boolean {
  return attempt > MAX_REJOIN_ATTEMPTS
}
